var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.75 0 23.35 24.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#737c81",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.724 9.949a9.2 9.2 0 0118.4 0v7.474a1.725 1.725 0 001.725 1.725H0a1.725 1.725 0 001.725-1.725zM13.741 21.449a2.875 2.875 0 01-5.634 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M13.799 4.74a5.176 5.176 0 012.874 4.635"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0wLjc1IDAgMjMuMzUgMjQuNSI+PGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNzM3YzgxIiBzdHJva2Utd2lkdGg9IjEuNSI+PHBhdGggZD0iTTEuNzI0IDkuOTQ5YTkuMiA5LjIgMCAwIDEgMTguNCAwdjcuNDc0YTEuNzI1IDEuNzI1IDAgMCAwIDEuNzI1IDEuNzI1SDBhMS43MjUgMS43MjUgMCAwIDAgMS43MjUtMS43MjVaIiAvPjxwYXRoIGQ9Ik0xMy43NDEgMjEuNDQ5YTIuODc1IDIuODc1IDAgMCAxLTUuNjM0IDAiIC8+PHBhdGggc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTEzLjc5OSA0Ljc0YTUuMTc2IDUuMTc2IDAgMCAxIDIuODc0IDQuNjM1Ii8+PC9nPjwvc3ZnPgo=";
export { SvgIconNotifications as ReactComponent };